import { get, put } from '@/services/http';

export type NoEtaHandling = 'before' | 'after';

export interface NoEtaHandlingResponse {
  handling: NoEtaHandling;
}

export class ReplenishmentSettingRecordModel {
  public id: number;
  public value: any;
  public status: string;
  public createdAt: string;
  public updatedAt: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.status = data.status;
    this.value = data.value;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  public mapData(data: any = {}) {
    this.id = data.id;
    this.status = data.status;
    this.value = data.value;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  /**
   * Get the no-ETA handling setting for incoming inventory
   * @returns The current no-ETA handling setting ('before' or 'after')
   */
  public static async getNoEtaHandling(): Promise<NoEtaHandling> {
    const res = await get('/replenishment_settings/no_eta_handling') as { data: NoEtaHandlingResponse };
    return res.data?.handling || 'after';
  }

  /**
   * Update the no-ETA handling setting for incoming inventory
   * @param handling - 'before' or 'after'
   */
  public static async updateNoEtaHandling(handling: NoEtaHandling): Promise<void> {
    await put('/replenishment_settings/no_eta_handling', { handling });
  }
}
